export enum PipelineKanbanSortEnum {
  consideration = 'consideration',
  size = 'size',
  agentGross = 'agent_gross',
  agentGrossProb = 'agent_gross_prob',
}
